(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('HistoricoAfericoesCtrl', HistoricoAfericoesCtrl);

  HistoricoAfericoesCtrl.$inject = [
    '$scope',
    '$rootScope',
    'LoadingService',
    '$q',
    'MessagesService',
    'ColheitaAfericaoService',
    'MaquinasService',
    'AtividadesService',
    '$templateCache',
    'OperacoesDadosService',
    '$routeParams'
  ];

  // eslint-disable-next-line max-params, max-lines-per-function
  function HistoricoAfericoesCtrl($scope, $rootScope, LoadingService,
    $q, MessagesService, ColheitaAfericaoService, MaquinasService,
    AtividadesService, $templateCache, OperacoesDadosService, $routeParams) {
    const vm = this;
    let hasPage = true;
    let inProgress = false;

    //////////////////////////////////////////
    // Controller data
    vm.initialized = false;
    vm.loadingAfericoes = false;
    vm.filters = {
      page: 1
    };
    vm.initialized = false;
    vm.afericoes = [];

    //////////////////////////////////////////
    // Bindable methods
    vm.setFilterAttribute = setFilterAttribute;
    vm.list = list;
    vm.selectAfericao = selectAfericao;

    //////////////////////////////////////////
    // Function declarations
    function initializeVariables() {
      hasPage = true;
      inProgress = false;
      vm.afericoes = [];
      vm.filters.page = 1;
    }

    function list() {
      const hasFilterPage = hasPage && vm.filters && vm.filters.page;
      if (hasFilterPage && !inProgress) {
        LoadingService.showLoading();
        inProgress = true;
        vm.loadingAfericoes = true;

        ColheitaAfericaoService.summarized(vm.filters)
          .then((data) => {
            const dados = data.data || [];
            hasPage = (((data.pages || {}).pagination || {}).next || 0) > vm.filters.page;
            if (dados.length) {
              vm.filters.page++;
              vm.afericoes = vm.afericoes.concat(dados);
            }
          })
          .catch((error) => {
            console.error('Falha ao buscar dados de colheita aferição!', error);
            MessagesService.alert('Falha ao buscar dados de colheita aferição!');
          })
          .finally(() => {
            inProgress = false;
            vm.loadingAfericoes = false;
            LoadingService.hideLoading();
          });
      }
    }

    function getFiltersData() {
      const promises = [
        MaquinasService.list(),
        AtividadesService.list()
      ];

      $q.all(promises).then(([maquinas, atividades]) => {
        vm.maquinas = maquinas.data || [];
        vm.atividades = atividades.data || [];
      });
    }

    /**
     * Sets filter attribute based on selected option
     *
     * @param {string} attribute attribute to be set
     * @param {any} object object with value
     * @param {Event} event click event
     */
    function setFilterAttribute(attribute, object, event) {
      if (event) {
        event.preventDefault();
      }
      initializeVariables();
      vm.filters[attribute] = object;
      list();
    }

    function deactivateAfericoes(selected = null) {
      vm.afericoes
        .filter((afericao) => afericao !== selected)
        .forEach((afericao) => {
          afericao.selected = false;
        });
    }

    function selectAfericao(selected) {
      selected.selected = !selected.selected;

      deactivateAfericoes(selected);

      if (selected.selected) {
        if (!selected.markers) {
          const template = $templateCache.get('views/infowindow_templates/infowindowoperations.tpl.html');
          LoadingService.showLoading();
          return loadMarkers(selected)
            .then((data) => {
              selected.markers = OperacoesDadosService.newGetMarkersOperationsDayGleba(data, null, template);
              $scope.$emit('setMarkers', selected.markers);
              $scope.$emit('setFocusedGleba', selected.cd_gleba);
            })
            .catch((error) => {
              console.error(error);
              MessagesService.alert('Não foi possível carregar os pontos da aferição selecionada.');
              selected.selected = false;
            })
            .finally(LoadingService.hideLoading);
        }
        $scope.$emit('setFocusedGleba', selected.cd_gleba);
        return $scope.$emit('setMarkers', selected.markers);
      }
      $scope.$emit('setFocusedGleba', null);
      $scope.$emit('clearMarkers');
    }

    function loadMarkers(afericao) {
      return ColheitaAfericaoService.list({
        maquina: afericao.cd_maquina,
        gleba: afericao.cd_gleba,
        safra: _.get(vm.filters.safra, 'id', null)
      })
        .then(({ data }) => data);
    }

    const initListener = $scope.$watch('wrap.activeTab', (value) => {
      if (value === 'colheita_afericao') {
        $scope.$root.initialize.then(() => {
          LoadingService.showLoading();
          initializeVariables();

          getFiltersData();
          list();
        }).catch($rootScope.errorRootInitialize)
          .finally(() => {
            vm.initialized = true;
            LoadingService.hideLoading();
            initListener();
          });
      }
    });

    $scope.$on('$routeUpdate', () => {
      if ($routeParams.activeTab !== 'colheita_afericao') {
        deactivateAfericoes();
      }
    });

    $scope.$on('$destroy', () => {
      $scope.$emit('setFocusedGleba', null);
      $scope.$emit('clearMarkers');
    });
  }
}());
